import type { RouteAlternative } from './googleMaps';

const DISTANCE_TOLERANCE_KM = 0.05;

// Index of the route a saved entry was calculated with, or -1 when none of the routes match.
// Prefers an unambiguous summary (road name) match, else the closest distance within tolerance.
export function findSavedRouteIndex(
  routes: Pick<RouteAlternative, 'summary' | 'distanceKm'>[],
  savedSummary: string | null | undefined,
  savedDistanceKm: number | null | undefined,
): number {
  const summary = savedSummary?.trim();
  if (summary) {
    const matches = routes.flatMap((r, i) => (r.summary?.trim() === summary ? [i] : []));
    if (matches.length === 1) return matches[0]!;
  }

  if (savedDistanceKm == null || !Number.isFinite(savedDistanceKm)) return -1;
  let best = -1;
  let bestDiff = Infinity;
  routes.forEach((r, i) => {
    const diff = Math.abs(r.distanceKm - savedDistanceKm);
    if (diff <= DISTANCE_TOLERANCE_KM && diff < bestDiff) {
      best = i;
      bestDiff = diff;
    }
  });
  return best;
}
